import { Alert, Button, Col, Flex, Form, Input, message, Modal, Row, Space, Spin, theme, Upload } from "antd";
import React, { useEffect, useState, useRef } from "react";
import { nameFieldValidator } from "../helper";
import { renderInfoTip } from "../../us_privacy_regulation/helper";
import TextEditor from "./TextEditor";

const CreateLegalDocumentModalEditor = (props) => {
  const [form] = Form.useForm();
  const [file, setFile] = useState(null);
  const [showDocNameAlert, setShowDocNameAlert] = useState(false);

  const getWrappedHtmlRef = useRef(null);

  useEffect(() => {
    if(props.docTypeGroup) {
      form.setFieldValue("documentName", props.docTypeGroup.documentName);
    }
  },[props.docTypeGroup])

  const onValuesChange = async (changedValues, allValues) => {
    if(changedValues.documentName) {
      try {
        await form.validateFields(["documentName"])
      } catch(err) {
        if(err.errorFields?.length && err.errorFields.some((obj) => obj.errors?.some((msg) => msg?.includes("already exists")))) {
          setShowDocNameAlert(true);
        } else {
          setShowDocNameAlert(false)
        }
      }
    }
  }

  const onFinish = (arg, publish) => {
    const content = getWrappedHtmlRef.current?.();
    const document = {
      documentName: arg.documentName,
      content,
      versionName: arg.versionName,
      webPageLink: arg.webPageLink,
    }

    props.handleSaveDocument(document, !props.docTypeGroup, publish)
  }

  const onFinishFailed = (arg) => {
    //validations
  }

  const { token } = theme.useToken();



  return (
    <Modal
      className="legal-doc-edit-modal"
      title="Text Editor"
      onCancel={props.onCancel}
      open={props.open}
      width={1366}
      destroyOnClose={true}
      confirmLoading={props.loading}
      footer={() => (
        <Flex gap={token.margin} justify="flex-end" align="center">
          {showDocNameAlert ? (
            <Alert
              type="warning"
              showIcon
              message="To upload a new version under an existing document go to the homepage and use the upload button next to the relevant document name."
            />
          ) : null}
          <Space>
            <Button
              onClick={() => {
                form.validateFields().then((values) => onFinish(values, false));
              }}
            >
              Save as Draft
            </Button>
            <Button
              type="primary"
              loading={props.loading}
              onClick={() => {
                form.validateFields().then((values) => onFinish(values, true));
              }}
            >
              Publish
            </Button>
          </Space>
        </Flex>
      )}
    >
      <Spin spinning={props.loading}>
      <Form
        form={form}
        name="ldms"
        layout="vertical"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        onValuesChange={onValuesChange}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        requiredMark={"optional"}
        // validateTrigger={"onSubmit"}
      >
        <Row gutter={[20, 16]}>

          <Col span={props.docTypeGroup ? 0 : 8}>
            <Form.Item label={<>Document name {renderInfoTip("The name of the new document category you're creating.")}</>} required>
              <Space direction="vertical" size={token.marginXXS}>
                <Form.Item
                  name={"documentName"}
                  rules={[
                    {
                      required: true,
                      message: "Please enter Document Name"
                    },
                    {
                      validator: (_,value) => nameFieldValidator(value, props.documentNames, "Document name")
                    }
                  ]}
                  hidden={props.docTypeGroup}
                  required={true}
                >
                  <Input maxLength={255} showCount={true}/>
                </Form.Item>
              </Space>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label={<>Version name{renderInfoTip("Defaults to the file name but can be edited. Helps track document versions.")}</>}
              name={"versionName"}
              rules={[
                {
                  required: true,
                  message: "Please enter Version Name"
                },
                {
                  validator:(_,value) => nameFieldValidator(value, props.docTypeGroup?.documents?.map((doc) => doc.versionName), "Version name!")
                }
              ]}
              required={true}
            >
              <Input maxLength={255} showCount={true}/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item 
              label={<>Webpage Link{renderInfoTip(" The link to the document that users will see.")}</>}
              required={false}
              name={"webPageLink"}
              rules={[
                {
                  type: "url"
                }
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="textEditor"
              rules={[
                {
                  required: true,
                  message: "Please enter text",
                },
              ]}
            >
              <TextEditor
                value={form.getFieldValue("textEditor")}
                onChange={(val) => form.setFieldValue("textEditor", val)}
                sites={props.sites}
                getWrappedHtmlRef={getWrappedHtmlRef}
                features={props.features}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      </Spin>
    </Modal>
  );
}

export default CreateLegalDocumentModalEditor;